import axiosRoot from 'axios';
import config from '../config.json';

/**
 * zet de authorizatie header en de base url voor de axios request
 */
export const axios = axiosRoot.create({
	baseURL: config.base_url_api,
	headers: {
		// Make sure an existing token is set before the first request is executed
		Authorization: `Bearer ${localStorage.getItem(config.token_key)}`,
	}
});

/**
 * stelt de token in of als er geen token is verwijderd het de autorisatie header
 * @param {string} token 
 */
export const setAuthToken = (token) => {
	if (token) {
		axios.defaults.headers['Authorization'] = `Bearer ${token}`;
	} else {
		delete axios.defaults.headers['Authorization'];
	}
}